import { render } from "./SecureUploadAnalysis.vue?vue&type=template&id=5f97a683&scoped=true"
import script from "./SecureUploadAnalysis.vue?vue&type=script&lang=js"
export * from "./SecureUploadAnalysis.vue?vue&type=script&lang=js"

import "./SecureUploadAnalysis.vue?vue&type=style&index=0&id=5f97a683&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f97a683"]])

export default __exports__